@let syncNotInstalledDialog = {
  titleKey: 'outlookSync.syncNotInstalled.title',
  descriptionKey: 'outlookSync.syncNotInstalled.description'
};

@let limitReachedDialog = {
  titleKey: 'outlookSync.limitReached.title',
  descriptionKey: 'outlookSync.limitReached.description'
};

@let emailSyncDisabledDialog = {
  titleKey: 'outlookSync.emailSyncDisabled.title',
  descriptionKey: 'outlookSync.emailSyncDisabled.description'
};

@if (isEmailSubscriptionLimitDialogOpen) {
  <kendo-dialog
    (close)="closeDialog()"
    [width]="490"
    [maxHeight]="230"
  >
    <ng-container
      *ngTemplateOutlet="dialogContentTemplate; context: limitReachedDialog"
    ></ng-container>
    <div class="flex justify-end py-5">
      <button
        kendoButton
        class="uppercase min-w-16"
        themeColor="secondary"
        (click)="closeDialog()"
      >
        {{ 'outlookSync.buttons.cancel' | translate }}
      </button>

      <button
        kendoButton
        class="uppercase min-w-16 ml-3"
        themeColor="primary"
        (click)="openAppStore()"
      >
        {{ 'outlookSync.buttons.reviewList' | translate }}
      </button>
    </div>
  </kendo-dialog>
}

@if (isEmailSyncDisabledDialogOpen) {
  <kendo-dialog (close)="closeDialog()" [width]="490" [maxHeight]="260">
    <ng-container
      *ngTemplateOutlet="
        dialogContentTemplate;
        context: emailSyncDisabledDialog
      "
    ></ng-container>
    <div class="flex justify-end pb-5">
      <button
        kendoButton
        class="min-w-16"
        themeColor="secondary"
        (click)="closeDialog()"
      >
        {{ 'outlookSync.buttons.close' | translate }}
      </button>

      <button
        kendoButton
        class="min-w-16 ml-3"
        themeColor="primary"
        (click)="openAppStore()"
      >
        {{ 'outlookSync.buttons.openSyncConfig' | translate }}
      </button>
    </div>
  </kendo-dialog>
}

@if (isSyncNotInstalledDialogOpen) {
  <kendo-dialog (close)="closeDialog()" [width]="500" [maxHeight]="400">
    <ng-container
      *ngTemplateOutlet="
        dialogContentTemplate;
        context: syncNotInstalledDialog
      "
    ></ng-container>
    <div class="flex justify-end pb-5">
      <button
        kendoButton
        class="min-w-16"
        themeColor="secondary"
        (click)="closeDialog()"
      >
        {{ 'outlookSync.buttons.close' | translate }}
      </button>

      <button
        kendoButton
        class="min-w-16 ml-3"
        themeColor="primary"
        (click)="openOutlookStore()"
      >
        {{ 'outlookSync.buttons.installOutlook' | translate }}
      </button>
    </div>
  </kendo-dialog>
}

@if (isLoading) {
  <maximizer-loader type="legacy" style="z-index: 100000"></maximizer-loader>
}

<!-- This is necessary for the Notification so it can show up in a correct position -->
<div #notificationContainer class="w-full h-full contents"></div>

<maximizer-notification
  icon="check"
  type="success"
  [hideAfter]="2000"
  #successNotification
  animation="fade"
  [appendTo]="notificationContainerRef"
>
</maximizer-notification>

<ng-template
  #dialogContentTemplate
  let-titleKey="titleKey"
  let-descriptionKey="descriptionKey"
>
  <h6 class="my-2">
    {{ titleKey | translate }}
  </h6>
  <div class="flex items-center">
    <div class="order-1 ml-2 mr-4">
      <span
        class="fa-icons icon-regular icon-32 icon-circle-exclamation text-warning"
      ></span>
    </div>
    <div class="order-2 mb-4">
      <span class="dialog-description block text-body-2 whitespace-break-spaces" [innerHTML]="(descriptionKey | translate)">
      </span>
    </div>
  </div>
</ng-template>

<maximizer-notification
  icon="check"
  type="error"
  [hideAfter]="2000"
  #errorNotification
  [appendTo]="notificationContainerRef"
>
</maximizer-notification>
